import { writable } from 'svelte/store';
function createActiveFlyoutStore() {
    const { subscribe, set, update } = writable(null);
    function open(flyoutState) {
        set(flyoutState);
    }
    function close(id) {
        update((state) => {
            if (state?.id === id) {
                return null;
            }
            return state;
        });
    }
    return {
        subscribe,
        update,
        open,
        close,
    };
}
export const activeFlyoutStore = createActiveFlyoutStore();
